module.exports = __webpack_public_path__ + "static/media/Sri Lanka.6e158613.png";